// Core
import React from 'react';

// Hooks
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { useOverflowTooltip } from '../../hooks/useOverflowTooltip/useOverflowTooltip';

// Components
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../../layout/elements/Paragraph';
import { Tooltip } from '../../layout/elements/Tooltip';

// Component
import {
  Container,
  Content,
  DescriptionContainer,
  IconContainer,
} from './MachineCard.style';
import { MachineCardProps } from './MachineCard.types';

function MachineCard({
  className,
  description,
  icon,
  onClick,
  testId,
}: MachineCardProps): JSX.Element {
  const { isXs } = useBreakpoint();

  const {
    containerRef,
    contentRef,
    isTooltipVisible,
  } = useOverflowTooltip({
    overflowCheckTriggers: description,
    widthOffset: 16,
  });

  return (
    <Container
      className={className}
      data-testid={testId}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <IconContainer>
        {icon}
      </IconContainer>
      <Content ref={containerRef}>
        {isTooltipVisible ? (
          <Tooltip text={description}>
            <DescriptionContainer ref={contentRef}>
              <Paragraph
                weight={ParagraphWeight.bold}
                size={
                  isXs
                    ? ParagraphSize.md
                    : ParagraphSize.lg
                }
                preventOverflow
              >
                {description}
              </Paragraph>
            </DescriptionContainer>
          </Tooltip>
        ) : (
          <DescriptionContainer ref={contentRef}>
            <Paragraph
              weight={ParagraphWeight.bold}
              size={
                isXs
                  ? ParagraphSize.md
                  : ParagraphSize.lg
              }
              preventOverflow
            >
              {description}
            </Paragraph>
          </DescriptionContainer>
        )}
      </Content>
    </Container>
  );
}

export { MachineCard };
